export enum CarouselItems {
  VOTW = 'votw',
  Video = 'video',
  VideoDetail = 'video-detail',
  Gps = 'gps',
  GpsDetail = 'gps-detail',
  Workout = 'workout',
  WorkoutDetail = 'workout-detail',
  Coaching = 'coaching',
  CoachingDetail = 'coaching-detail',
  Playlist = 'playlist',
  VideoPoster = 'video-poster',
  Landscape = 'landscape',
  Region = 'region',
  Other = 'other',
}
